/**
 * @description Renders the header of the Assign Contract page, which includes some basic
 *  information about the contract that personnel are being assigned to
 */

import React from 'react';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import withErrorBoundary from '@seccon/shared/ui/hocs/with-error-boundary';
import { ContractInfoContext } from '../contexts/contractInfo';

const styles = {
  title: {
    display: 'flex',
    flexWrap: 'nowrap',
    gap: 2
  }
};

const AssignContractPersonnel = () => {
  const contract = React.useContext(ContractInfoContext);

  return (
    <Stack>
      <Typography variant='h4'>
        Assign Contract Personnel
      </Typography>
      {contract?.name && (
        <Typography variant='subtitle1' sx={styles.title}>
          {contract.name}
          <Chip label={`Contract Number: ${ contract.number ?? 'Not found' }`} size='small' />
          <Chip label={contract.clearanceLevel ?? 'Unknown'} size='small' />
        </Typography>
      )}
    </Stack>
  );
};

export default withErrorBoundary(AssignContractPersonnel);
